// extracted by mini-css-extract-plugin
export default {"container":"e9tgDxs9otxD8SlwPWFM__container___"};